export default "<div class=\"jumbotron\" style=\"background-color: #fff; height: calc(95vh);\">\n  <p>about works!</p>\n</div>\n"